export default __webpack_public_path__ + "static/blob5-d7246b7910c7917838d9fb3ff5ece48f.svg";